/* Product Review Tooltip */
$(document).ready(function () {
  $('.product__review__tooltip .review-slider').slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  });

  $('.js-review-tooltip-close').click(() => {
    $('.product__review__tooltip').addClass('hidden');
  });

  $('.js-show-tooltip').click(() => {
    if ($('.product__review__tooltip').hasClass('hidden')) {
      $('.product__review__tooltip').removeClass('hidden');
      return 
    }

    $('.product__review__tooltip').addClass('hidden');
  });
});



document.addEventListener("DOMContentLoaded", () => {
  function init() {
    const checkbox = document.querySelector(".kaching-bundles__subscriptions__checkbox");
    const bars = document.querySelector(".kaching-bundles__bars");

    if (!checkbox || !bars) {
      //console.warn("⚠️ Checkbox or Bars element not found — waiting...");
      return false;
    }

    //console.log("✅ Elements found — starting observer");

    function toggleUpsell() {
      const svg = checkbox.querySelector("svg");
      const upsells = bars.querySelectorAll(".kaching-bundles__upsell");
      const svgVisible = svg && (svg.offsetWidth > 0 || svg.offsetHeight > 0 || svg.getClientRects().length > 0);

      if (svgVisible) {
        upsells.forEach(u => {
          u.style.setProperty("display", "block", "important");
        });
        console.log("🟢 SVG visible → Showing all upsells");
        window.kachingBundlesDisableAddToCartHandling = false;
      } else {
        upsells.forEach(u => {
          u.style.setProperty("display", "none", "important");
          u.classList.remove("kaching-bundles__upsell__checkbox--selected");
        });
        console.log("🔴 SVG not visible → Hiding all upsells and removing 'selected' class");
        window.kachingBundlesDisableAddToCartHandling = true;
      }
    }

    // Run once initially
    toggleUpsell();

    // Observe SVG or checkbox DOM changes
    const observer = new MutationObserver(toggleUpsell);
    observer.observe(checkbox, { childList: true, subtree: true, attributes: true });

    console.log("👀 Watching for checkbox SVG visibility changes...");
    return true;
  }

  // Keep checking until DOM ready
  let tries = 0;
  const wait = setInterval(() => {
    const ready = init();
    tries++;
    if (ready || tries > 40) { // ~8 seconds
      clearInterval(wait);
    }
  }, 200);
});






// https://docs.google.com/document/d/1vKEL2v62omqJ1apWX_gY81XfQnerEFVvn0kzNRoojzI/edit?tab=t.0


// https://support.kachingappz.com/en/articles/8609400-event-listeners-for-kaching-quantity-bundles-widget